import { createReducer, on } from '@ngrx/store';
import * as Actions from './organizations.actions';
import { organizationsInitState } from './organizations.state';

export const organizationsReducer = createReducer(
  organizationsInitState,

  on(Actions.SetCurrentOrganization, (state, { orgId }) => ({
    ...state,
    current: orgId?.toLowerCase(),
  })),

  on(Actions.SetLastOrganization, (state, { orgId }) => ({
    ...state,
    last: orgId?.toLowerCase() ?? state.last,
  })),

  on(Actions.LoadOrganizations, (state) => ({
    ...state,
    loading: true,
  })),

  on(
    Actions.LoadOrganizationsSuccess,
    (state, { organizationIds, organizations }) => ({
      ...state,
      count: organizationIds?.length,
      organizationIds,
      organizations,
      loading: false,
      error: null,
    }),
  ),

  on(Actions.UpdateOrgPath, (state, { organizationId, path }) => ({
    ...state,
    organizations: {
      ...state.organizations,
      [organizationId]: {
        ...state.organizations[organizationId],
        path: path,
      },
    },
  })),

  on(Actions.LoadOrganizationsError, (state, { error }) => ({
    ...state,
    count: 0,
    organizationIds: [],
    organizations: {},
    error,
    loading: false,
  })),
);
